import React from 'react'
import V1 from './v1'
import V2 from './v2'
import { DepartmentType } from '#src/generated/graphql'
import { SellableCardCarouselProps } from '#src/components/SellableCardCarousel'
import { Experiment, Variation } from '@deal/experiment-js'

export interface SellableCardCarouselExperimentProps extends SellableCardCarouselProps {
  title: React.ReactNode
  subTitle?: React.ReactNode
  department: DepartmentType
  aspectRatio?: 'tall' | 'wide'
}

const SellableCardCarouselExperiment: React.SFC<SellableCardCarouselExperimentProps> = ({
  ...rest
}) => {
  return (
    <Experiment id="sellable-card-carousel" default="v1">
      <Variation id="v1">
        <V1 {...rest} />
      </Variation>
      <Variation id="v2">
        <V2 {...rest} />
      </Variation>
    </Experiment>
  )
}

export default SellableCardCarouselExperiment
